import styled, { css } from "styled-components";
import { EmailTitleWrapper, TitleWrapper } from "../Step1Setup/styles";
import { Err } from "../Step1Setup/styles";

const fontCommonStyles = css`
  font-family: HelveticaNeue;
  font-size: 16px;
  color: #505050;
`;

export const Heading = styled.h1`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.primary};
  color: ${props => props.theme.fontColors.headingColor};
  margin-bottom: ${props => props.marginBottom};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const BestowHeading = styled(Heading)`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  font-size: ${props => props.theme.fontSize.primary};
`;

export const SubHead = styled.div`
  ${fontCommonStyles}
  line-height: 1.5;
  margin-bottom: 20px;
  letter-spacing: 0px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
  }
`;

export const SuccessionSubhead = styled(SubHead)`
  margin-bottom: 30px;
`;

export const EndowHeading = styled(Heading)`
  padding-top: 10px;
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  font-size: ${props => props.theme.fontSize.heading};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    letter-spacing: 0px !important;
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  }
`;

export const FundNameWrap = styled.div`
  display: flex;
  margin-bottom: 56px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 16px;
  }
`;

export const FundLeft = styled.div`
  ${fontCommonStyles}
  line-height: 1.5;
  margin: 10px 20px 0 0;
  letter-spacing: 0px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 30px 10px 0 0;
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;
export const FundRight = styled.span`
  ${fontCommonStyles}
  line-height: 1.5;
  margin: 10px 0 0 20px;
  letter-spacing: 0px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 30px 0 0 10px;
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const InputWrap = styled.div`
  margin-top: -20px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-top: 0px;
    font-size: ${props => props.theme.fontSize.secondary};
  }
  .ant-input {
    width: 355px;
    height: 40px;
    border-radius: 0;

    @media only screen and (min-width: 320px) and (max-width: 767px) {
      width: 231px;
      font-size: ${props => props.theme.fontSize.secondary};
    }
  }
`;

export const Content = styled.div`
  ${fontCommonStyles}
  letter-spacing: 0px;
  padding: 7px 0 30px 18px;
  width: 700px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    padding: 7px 20px 30px 20px;
    font-size: 14px;
    width: 273px;
  }
`;

export const MainWrapper = styled.div`
  @media only screen and (min-width: 767px) {
    .ant-row .ant-form-item-label {
      /* width: 59.6%; */
      margin-top: 16px;
    }
  }
`;

export const PercentageWrapper = styled(MainWrapper)`
  margin-bottom: 16px;
`;
export const EmailTitleWrapperFont = styled(EmailTitleWrapper)`
  //margin-top: 16px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
    margin-top: 14px;
  }
`;

export const PercentageTitle = styled(EmailTitleWrapperFont)`
  margin-top: 0px;
`;

export const TitleWrapperFont = styled(TitleWrapper)`
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
  }
`;

export const ErrMargin = styled(Err).attrs(props => ({
  className: "error-fields-ooa-2"
}))`
  margin-top: -20px;
`;

export const MarginComponent = styled.div`
  margin-top: 10px;
`;

export const MarginComponentDrop = styled.div`
  margin-top: 16px;
`;

export const MarginWrapper = styled.div`
  margin: 20px 0px;
`;